import { render, staticRenderFns } from "./BodegasWellboat.vue?vue&type=template&id=b0d84146"
import script from "./BodegasWellboat.vue?vue&type=script&lang=js"
export * from "./BodegasWellboat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports